import React from 'react';
import { Container, Typography, Box, Breadcrumbs, Link } from '@mui/material';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { NavigateNext } from '@mui/icons-material';
import BreadcrumbJsonLd from '../../components/seo/BreadcrumbJsonLd';

interface LegalLayoutProps {
  title: string;
  children: React.ReactNode;
}

const LegalLayout: React.FC<LegalLayoutProps> = ({ title, children }) => {
  const location = useLocation();
  const pathSegments = location.pathname.split('/').filter(Boolean);

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <BreadcrumbJsonLd
        items={[
          { name: 'Начало', url: '/' },
          { name: title },
        ]}
      />
      <Box sx={{ mb: 3 }}>
        <Breadcrumbs
          separator={<NavigateNext fontSize="small" />}
          aria-label="breadcrumb"
          sx={{ mb: 2 }}
        >
          <Link
            component={RouterLink}
            to="/"
            color="inherit"
            underline="hover"
          >
            Начало
          </Link>
          <Typography color="text.primary">{title}</Typography>
        </Breadcrumbs>
        
        <Typography variant="h3" component="h1" gutterBottom sx={{ fontWeight: 600 }}>
          {title}
        </Typography>
      </Box>
      
      <Box sx={{ '& > *': { mb: 3 } }}>
        {children}
      </Box>
      
      <Box sx={{ mt: 6, p: 3, bgcolor: 'grey.50', borderRadius: 1 }}>
        <Typography variant="body2" color="text.secondary">
          <strong>Последна актуализация:</strong> 15 август 2025 г.
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
          За въпроси относно тези условия, моля свържете се с нас на{' '}
          <Link href="mailto:info@goldenbooks.bg" color="primary">
            info@goldenbooks.bg
          </Link>
        </Typography>
      </Box>
    </Container>
  );
};

export default LegalLayout;